import LineChart from './VariableLineGraph'
import AreaChart from './VariableAreaGraph'

export default { LineChart, AreaChart }
